export const slide_contents = [
    {
        no: 0,
        title: 'Step 1',
        description: 'Open the Pinterest App or Website on your iPhone',
        image: '/static/images/T1.png'
    },
    {
        no: 1,
        title: 'Step 2',
        description: `Select the Pin you want to save and click "Share" icon`,
        image: '/static/images/T2.png'
    },
    {
        no: 2,
        title: 'Step 3',
        description: `Tap on "Copy Link"`,
        image: '/static/images/T3.png'
    },
    {
        no: 3,
        title: 'Step 4',
        description: `Go to back PinSaver App, click "Save PIN" button and then paste the "Link"`,
        image: '/static/images/T4.png'
    },
    {
        no: 4,
        title: 'Step 5',
        description: `Click "Save" and wait until it's done`,
        image: '/static/images/T5.png'
    },
    {
        no: 5,
        title: 'Step 6',
        description: `Tap on the "Three dots" icon, click on "Share the Pin" and share it to other apps`,
        image: '/static/images/T6.png'
    },
]